// import store from '@/store'
import checkPermission from '@/utils/permission'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding

    if (!checkPermission(value)) {
      // 移除渲染node
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
